import React from 'react';
import { connect } from 'react-redux';

import { FocusPointsContainer } from '../../../Shared/index';
import questionActions from '../../actions/questions';

const ConnectFocusPointsContainer = ({ focusPoints, match, dispatch }) => {
  const { questionID } = match.params;
  const baseUrl = `#${match.url}`;

  const handleUpdateFocusPoints = (questionID, focusPoints, callback) => {
    dispatch(questionActions.submitBatchEditedFocusPoint(questionID, focusPoints, callback));
  };

  const handleDeleteFocusPoint = (questionID, focusPointID) => {
    dispatch(questionActions.deleteFocusPoint(questionID, focusPointID));
  };

  const handleSubmitEditedFocusPoint = (questionID, data, key) => {
    dispatch(questionActions.submitEditedFocusPoint(questionID, data, key));
  };

  return (
    <FocusPointsContainer
      baseUrl={baseUrl}
      focusPoints={focusPoints}
      onDeleteFocusPoint={handleDeleteFocusPoint}
      onSubmitEditedFocusPoint={handleSubmitEditedFocusPoint}
      onUpdateFocusPoints={handleUpdateFocusPoints}
      questionID={questionID}
    />
  );
};

function select(state, ownProps) {
  const { questionID } = ownProps.match.params;
  const question = state.questions.data[questionID];

  return {
    focusPoints: question?.focusPoints || {},
  };
}

export default connect(select)(ConnectFocusPointsContainer);
